import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import NewsDrawer from 'components/drawer/NewsDrawer';
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";
import { useState } from "react";
import { FiEye } from "react-icons/fi";
import Tooltip from "components/tooltip/Tooltip";
import NewsViewModel from "components/modal/NewsViewModel";

const NewsTable = ({
    newsTabledata,
    hideEdit,
    hideDelete,

}) => {
    const { title, serviceId, handleModalOpen, handleUpdate, handleView } = useToggleDrawer();
    const newsdata = newsTabledata;
    const [preview, setPreview] = useState(null);

    const handleImagePreview = (imagePath) => {
        if (!imagePath) return "";
        const cleanPath = imagePath.replace(/\\/g, "/");
        return `${process.env.REACT_APP_API_IMAGE_URL}${cleanPath}`;
    };

    const truncateDescriptionWords = (text, wordLimit = 100) => {
        if (!text) return "";
        const words = text.split(" ");
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(" ") + " ...";
    };
    return (
        <>
            <DeleteModal id={serviceId} title={title} />

            <MainDrawer>
                <NewsDrawer id={serviceId} />
            </MainDrawer>
            <NewsViewModel id={serviceId} data={newsTabledata} title={"News Details"} />
            <div>
                {preview && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="relative bg-white p-4 rounded shadow-lg">
                            <button
                                onClick={() => setPreview(null)}
                                style={{ position: "absolute", right: "20px", top: "10px", fontSize: "30px", color: "#333", cursor: "pointer", hover: { color: "red" } }}
                            >
                                ×
                            </button>
                            <img
                                style={{ width: "700px", height: "auto", objectFit: "contain", padding: "40px" }}
                                src={preview}
                                alt="Preview"

                            />

                        </div>
                    </div>
                )}

            </div>
            <TableBody>
                {newsdata?.map((data, index) => (
                    <TableRow key={data?.id}>

                        <TableCell className="text-sm text-center">
                            {index + 1}
                        </TableCell>

                        <TableCell className="text-sm text-center">
                            {data?.title}
                        </TableCell>

                        <TableCell className="max-w-sm break-words whitespace-normal leading-relaxed text-sm text-center">
                            <div className="">
                                {truncateDescriptionWords(data?.description, 20)}
                            </div>

                        </TableCell>


                        <TableCell className="text-center">

                            <img
                                src={handleImagePreview(data?.news_image)}
                                alt={data?.title}
                                className="h-20 w-20 object-cover mx-auto rounded cursor-pointer"
                                onClick={() =>
                                    setPreview(handleImagePreview(data?.news_image))
                                }
                            />


                        </TableCell>

                        <TableCell className="text-sm text-center">
                            <a
                                href={data?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                News Title
                                {/* {data?.title} */}
                            </a>
                        </TableCell>

                        <TableCell className="text-sm text-center">
                            <ShowHideButton
                                id={data?.id}
                                status={data?.status}
                                Loading={true}
                            />
                        </TableCell>

                        <TableCell className="text-center">

                            <div className="flex justify-center text-right">
                                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                                    <button
                                        onClick={() =>
                                            handleView(data.id, "News Details")
                                        }
                                        className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                                    >
                                        <Tooltip
                                            id={data.id}
                                            Icon={FiEye}
                                            title="ViewOrder"
                                            bgColor="#34D399"
                                        />
                                    </button>
                                </div>
                                <EditDeleteButton
                                    title={"News"}
                                    id={data.id}
                                    handleUpdate={handleUpdate}
                                    handleModalOpen={handleModalOpen}
                                    hideEdit={hideEdit}
                                    hideDelete={hideDelete}
                                />
                            </div>
                            {/* <EditDeleteButton
                                title="News"
                                id={data?.id}
                                handleUpdate={handleUpdate}
                                handleModalOpen={handleModalOpen}
                                hideDelete={hideDelete}
                                hideEdit={hideEdit}
                            /> */}
                        </TableCell>

                    </TableRow>
                ))}
            </TableBody>

        </>
    );
};

export default NewsTable;
